import { AxiosInstance, AxiosResponse } from 'axios';
import { BaseSearch, PagedListContainer, RoleDTO } from '../types/ApiTypes';

export class RolesService {
    constructor(private axios: AxiosInstance) {}

    getAllRoles = async (searchParams: BaseSearch): Promise<AxiosResponse<PagedListContainer<RoleDTO>>> => {
        return this.axios.post('/Roles/GetAllRoles', searchParams);
    };
}

export default RolesService;
